// Home: "Your accounts" — one small card per LinkedIn account (2+ accounts only). Click to switch.

import type { IgAccountOverview } from "@ml/shared";
import { cx } from "@ml/ui";
import { useMemo } from "react";
import { Link } from "react-router";
import { shortRunLine } from "../../lib/accountStatus";
import { formatCount, formatNumber } from "../../lib/format";
import { useIgAccount, useIgAccountsOverview } from "../../lib/igAccount";
import { IgStatusAvatar } from "./IgSwitcherOption";
import "./ig-workspaces.css";

export function IgAccountsStrip() {
  const { accounts, current, switchAccount } = useIgAccount();
  const many = accounts.length > 1;
  const overview = useIgAccountsOverview({ enabled: many });
  const byId = useMemo(() => new Map<string, IgAccountOverview>((overview.data?.items ?? []).map((o) => [o.account.id, o])), [overview.data]);
  if (!many) return null;

  return (
    <section className="gfp-ws-strip" aria-labelledby="gfp-ws-strip-title">
      <div className="gfp-ws-strip__head">
        <h2 id="gfp-ws-strip-title" className="gfp-ws-strip__title">
          Your accounts
        </h2>
        <Link to="/settings?tab=instagram" className="gfp-ws-strip__manage">
          Manage
        </Link>
      </div>
      <ul className="gfp-ws-strip__list">
        {accounts.map((a) => {
          const o = byId.get(a.id);
          const acc = o?.account ?? a;
          const selected = a.id === current?.id;
          return (
            <li key={a.id}>
              <button
                type="button"
                className={cx("gfp-ws-mini", selected && "gfp-ws-mini--current")}
                aria-pressed={selected}
                title={shortRunLine(acc)}
                onClick={() => switchAccount(a.id)}
              >
                <IgStatusAvatar account={acc} size={36} />
                <span className="gfp-ws-mini__text">
                  <span className="gfp-ws-mini__handle">
                    {selected ? null : <span className="gf-sr-only">Switch to </span>}@{a.username}
                  </span>
                  <span className="gfp-ws-mini__meta">{formatCount(acc.followers)} followers</span>
                  {o ? (
                    <span className="gfp-ws-mini__meta">
                      {formatNumber(o.today.actions)} {o.today.actions === 1 ? "action" : "actions"} today
                    </span>
                  ) : null}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
